import * as Sentry from '@sentry/react';
import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataSimpleGridWithIllustration } from './SimpleGridWithIllustration.proptypes';

import Picture from '../../../../ui/Atoms/Picture';
import Text, { TextAppearance } from '../../../../ui/Atoms/Text';

import { getStaticUrl } from '../../../utils/getStaticUrl';

import * as S from './SimpleGridWithIllustration.styles';

const renderBoldTd = (items, isTitle) => {
  return (
    <S.StyledRow>
      {items.map((item, index) => {
        const text = isTitle
          ? item.simple_column_title
          : item.simple_subtitle || '';

        return <S.StyledTitle key={index}>{text}</S.StyledTitle>;
      })}
    </S.StyledRow>
  );
};

export const SimpleGridWithIllustration = ({ slice }) => {
  if (!slice) {
    return null;
  }

  const items = slice.items;
  if (items?.length < 1) {
    Sentry.captureMessage(
      'Error: missing required data in SimpleGridWithIllustration slice'
    );
    return null;
  }

  return (
    <S.Wrapper>
      {renderBoldTd(items, true)}
      <S.StyledRow>
        {items.map((item, index) => {
          const { alt, localFile } = item.simple_column_illustration;

          const imageProps = {
            imageObject: getImage(localFile),
            imageUrl: getStaticUrl(localFile?.publicURL),
            altText: alt,
            isNotLazy: false,
          };

          return (
            <S.Content key={index}>
              <S.PictureWrapper>
                <Picture {...imageProps} />
              </S.PictureWrapper>
            </S.Content>
          );
        })}
      </S.StyledRow>
      {renderBoldTd(items, false)}
      <S.StyledRow>
        {items.map((item, index) => {
          const content = item.simple_column_content?.html || '';

          return (
            <S.Content key={index}>
              <Text type={TextAppearance.NORMAL}>{content}</Text>
            </S.Content>
          );
        })}
      </S.StyledRow>
      <S.StyledRow>
        {items.map((item, index) => {
          const lastContent = item.simple_column_last_content?.html || '';

          return (
            <S.Content hasBackground={true} key={index}>
              <Text type={TextAppearance.NORMAL}>{lastContent}</Text>
            </S.Content>
          );
        })}
      </S.StyledRow>
    </S.Wrapper>
  );
};

SimpleGridWithIllustration.propTypes = {
  /**
   * Content of the SimpleGrid slice.
   */
  slice: PropTypes.shape(propTypesDataSimpleGridWithIllustration),
};
